import { useInitializer } from '../hooks/useInitializer.js';
export const Initializer = () => {
    useInitializer();
    return null;
};
//# sourceMappingURL=Initializer.js.map